import styles from './styles.module.css'
export const Footer = () => {
    return (
        <section className={styles.footer__section}>
            <div className={styles.footer}>
                Created by Michał Dziuba! 
            </div>
        </section>
    )
}